import { Observable, OperatorFunction } from 'rxjs'
import { NgZone } from '@angular/core'

// based on https://stackoverflow.com/questions/50928645/running-an-observable-into-a-zone-js
export function runInZone<T>(zone: NgZone): OperatorFunction<T, T> {
    return source => {
        return new Observable(observer => {
            const next = (value: T): void => zone.run(() => observer.next(value))
            const error = (e: any): void => zone.run(() => observer.error(e))
            const complete = (): void => zone.run(() => observer.complete())
            return source.subscribe({ next, error, complete })
        })
    }
}
